import NewCustomer from "../../../../components/@groups/customers/NewCustomer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomerGroupNewPage() {

    return (
        <NewCustomer 
            routeType={routeTypes.admin}
        />
    )
}       